import React, {PropsWithChildren, useEffect, useRef} from "react";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "swiper-container": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        init: boolean;
      };
      "swiper-slide": React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

type SwiperConstructType = {
  title: string;
  breakpoints?: BreakpointType;
  link?: React.ReactNode;
};
export type BreakpointType = {
  [key in 275 | 481 | 651 | 768 | 851 | 941 | 1132]?: {
    slidesPerView: number;
    slidesOffsetBefore?: number;
    slidesOffsetAfter?: number;
  };
};

type TemporarySwiperParamsType = {
  initialize?: () => void;
  mousewheel: {forceToAxis: true};
  navigation: {
    nextEl: HTMLSpanElement;
    prevEl: HTMLSpanElement;
  };
  slidesPerView: number;
  breakpoints: BreakpointType;
  slidesOffsetBefore: number;
  slidesOffsetAfter: number;
  spaceBetween: number;
};

export const defaultBreakpoints: BreakpointType = {
  481: {
    slidesPerView: 2.5,
  },
  768: {
    slidesPerView: 3.5,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
  },
  941: {
    slidesPerView: 4,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
  },
  1132: {
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    slidesPerView: 4,
  },
};

const SwiperConstruct: React.FC<PropsWithChildren<SwiperConstructType>> = ({
  children,
  title,
  link,
  breakpoints = defaultBreakpoints,
}) => {
  const swiperRef = useRef<HTMLElement & TemporarySwiperParamsType>(null);
  const prevSpanRef = useRef(null);
  const nextSpanRef = useRef(null);
  const childrenArray = React.Children.toArray(children);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.initialize && prevSpanRef.current && nextSpanRef.current) {
      swiperRef.current.parentElement?.classList.add("visible");
      swiperRef.current.classList.add("swiper-cross-selling__container");
      swiperRef.current.querySelectorAll("swiper-slide").forEach((slide) => slide.classList.add("swiper-slide-card"));
      swiperRef.current.slidesPerView = 2.5;
      swiperRef.current.spaceBetween = 16;
      swiperRef.current.slidesOffsetBefore = 16;
      swiperRef.current.slidesOffsetAfter = 16;
      swiperRef.current.mousewheel = {forceToAxis: true};
      swiperRef.current.breakpoints = breakpoints;

      swiperRef.current.navigation = {
        nextEl: nextSpanRef.current,
        prevEl: prevSpanRef.current,
      };
      swiperRef.current.initialize();
    }
  }, []);

  return (
    <div className="swiper-cross-selling m-0">
      <h2 className="swiper-cross-selling__title fill">{title}</h2>
      {link && <p className="swiper-cross-selling__link-placeholder">{link}</p>}
      <swiper-container init={false} ref={swiperRef}>
        {React.Children.map(childrenArray, (child, key) => {
          return <swiper-slide key={key}>{child}</swiper-slide>;
        })}
      </swiper-container>
      <div className="swiper-btn-prev" ref={prevSpanRef}>
        <span className="icon icon-chevron-left icon-size--32">&nbsp;</span>
      </div>
      <div className="swiper-btn-next" ref={nextSpanRef}>
        <span className="icon icon-chevron-right icon-size--32">&nbsp;</span>
      </div>
    </div>
  );
};

export default SwiperConstruct;
